import React from 'react'
import { css } from 'linaria'

const bulletCSS = css`
  li {
    @apply relative mb-4 text-lg;
  }
  li:before {
    content: '';
    width: 0.5rem;
    height: 0.5rem;
    left: -1.5rem;
    top: 8px;
    @apply block absolute bg-blue-100;
  }
`

const BulletList = ({ children, className }) => {
  return <ul className={`${bulletCSS} ${className || ''} pl-12`}>{children}</ul>
}

BulletList.propTypes = {}

BulletList.defaultProps = {}

export default BulletList
